module.exports = __webpack_public_path__ + "static/timbercreek-logo-0cd334d4dbd6725c2db58ae7a02da017.png";